// Projects are served from subdomains of these hosts, e.g. {project}.la28-staging.iventis.com
export const LA28_TRMS_HOSTNAME = "trms.la28.org";
export const LA28_PRODUCTION_HOSTNAME = "la28.iventis.com";
export const LA28_STAGING_HOSTNAME = "la28-staging.iventis.com";
